import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"

import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';
import studio from '../assets/images/studio.jpg';


const style = {
	backgroundImage: `url(${studio})`,
	backgroundSize: `cover`,
	backgroundPosition: `center`
}

class LandingContainer extends Component {
	render() {
		return (
			<Aux>
				<div className="grid-y" id="landing-page" style={style}>
				

				  <div className="small-12 grid-x align-center align-middle text-center cell">
				    <div className="small-12 cell text-center custom">

				    	<p><img className="logo" src={AMLogo} alt="" /></p>
				      <p className="top-title">Audition Magic Project Check-In Page</p>

				      <h6 className="subheader">Get Started</h6>
				      <div className="chooser">
				        <Link to="/client/login" className="button big white">I AM THE CLIENT</Link>
				        <Link to="/artist/login" className="button big dark-gray">I AM THE ARTIST</Link>				      
				      </div>
				    </div>
				  </div>

				</div>
			</Aux>
		)
	}
}

export default LandingContainer


// WEBPACK FOOTER //
// ./src/containers/LandingContainer.js